import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import { MyMButton } from '../../ui-elements/MyMButton';
import NewsDetail from '../MyM502_NewsDetail/NewsDetail';

/** MyMine Version1.5 NewsRegistrationInternal画面新規追加
 * NewsRegistrationInternalPreview Component
 */
const NewsRegistrationInternalPreview = ({ newsInfo, handleModalClose, controlSettings }) => {

  return (
    <>
      <Box sx={{ minHeight: '90%' }}>
        <NewsDetail previewNewsInfo={newsInfo} />
      </Box>
      <Stack direction='row' justifyContent="flex-end" alignItems="center" className='mt-3'>
        <MyMButton onClick={handleModalClose} >{controlSettings.LabelList.btnPreviewBack}</MyMButton>
      </Stack>
    </>
  );
}

export default NewsRegistrationInternalPreview